import { deviceDefaults } from "./deviceDefaults";
import { errorMessages, config } from "../../constants";
import { prefixEnvironmentSdrn, prefixUserSdrn } from "../sdrn";
import { formatDateString, getSentDate } from "../../utils/dates";
import type { EventBuilderInput } from "../../typings";

const createActorObject = (userId: string, userIdPrefix: string) => ({
  actor: {
    "@id": prefixUserSdrn(userId, userIdPrefix),
  },
});

export const buildBasePulseEvent = (input: EventBuilderInput) => {
  if (!input.visitorId) throw new Error(errorMessages.NO_VISITOR_ID);
  if (!input.uuid) throw new Error(errorMessages.NO_EVENT_UUID);

  const dateFromTimestamp = new Date(input.timestamp);
  const isAnonymousExperiment =
    input.campaignType === config.YELLOW_CAMPAIGN_KEY;
  const isIdentifiedExperiment = !isAnonymousExperiment;

  return {
    "@id": input.uuid,
    creationDate: formatDateString(dateFromTimestamp),
    sentDate: formatDateString(getSentDate()),
    deployStage: input.deployStage,
    device: {
      "@type": "Device",
      ...(isAnonymousExperiment && {
        environmentId: prefixEnvironmentSdrn(input.visitorId),
      }),
      ...deviceDefaults,
    },
    ...(isIdentifiedExperiment &&
      createActorObject(input.visitorId, input.userIdPrefix)),
    provider: {
      "@id": input.providerId,
      "@type": "Organization" as const,
    },
    schema: config.SCHEMA_URL,
    tracker: {
      name: "JS Event Dispatcher",
      type: "JS" as const,
      version: "__packageVersion__",
    },
  };
};
